let log = {};
log.init = function (kmf) {
    (function (para) {
        var p = para.sdk_url, n = para.name, w = window, d = document, s = 'script', x = null, y = null;
        if (typeof (w['sensorsDataAnalytic201505']) !== 'undefined') {
            return false;
        }
        w['sensorsDataAnalytic201505'] = n;
        w[n] = w[n] || function (a) { return function () { (w[n]._q = w[n]._q || []).push([a, arguments]); } };
        var ifs = ['track', 'quick', 'register', 'registerPage', 'registerOnce', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify', 'login', 'logout', 'trackLink', 'clearAllRegister', 'getAppStatus'];
        for (var i = 0; i < ifs.length; i++) {
            w[n][ifs[i]] = w[n].call(null, ifs[i]);
        }
        if (!w[n]._t) {
            x = d.createElement(s), y = d.getElementsByTagName(s)[0];
            x.async = 1;
            x.src = p;
            x.setAttribute('charset', 'UTF-8');
            w[n].para = para;
            y.parentNode.insertBefore(x, y);
        }
    })({
        sdk_url: '//code.kmf.com/dist/libs/sensors@1.14.5/sensorsdata.min.js',
        heatmap_url: '//code.kmf.com/dist/libs/sensors@1.14.5/heatmap.min.js',
        name: 'kmfSensors',
        server_url: 'https://sensorsdata.talbrain.com:8080/sa?project=Glo_KMF',
        show_log: true
    })
    if (kmf.pid != '0') {
        kmfSensors.login(kmf.pid);
    }
    kmfSensors.quick('autoTrackSinglePage', kmf.params);
}
export default log;
